import React from 'react';
import { useHistory } from 'react-router-dom';

export const RollCallSummary = (props) => {
  const history = useHistory();
  const sortedCallData = JSON.parse(localStorage.getItem('sortedData'));

  const date = new Date();

  React.useEffect(() => {
    props.hideLoader();
  }, [props]);

  return (
    <>
      <div className="container max-w-sm mx-auto bg-white-200 pt-6">
        <div
          className="mx-4 mt-48 pt-10 text-center"
          style={{
            width: '330px',
            height: '250px',
            left: '38px',
            top: '188px',
            backgroundColor: '#00AB11',
            border: '3px solid #000000',
            borderRadius: '20px',
            boxShadow: '2px 4px 2px 2px',
          }}
        >
          <h1
            style={{
              left: '53px',
              top: '244px',
              fontWeight: '700',
              fontSize: '30px',
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            Your Email has been sent to your Crisis Team at
          </h1>
          <h4 className="font-bold">
            {date.toLocaleString('default', { month: 'long' })} {date.getDate()}, {date.getFullYear()},{' '}
            {date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
          </h4>
        </div>

        <div className="mx-4 text-center pt-16 pb-8">
          <h1
            style={{
              top: '244px',
              fontWeight: '700',
              fontSize: '30px',
              display: 'flex',
              textAlign: 'center',
              color: '#000000',
            }}
          >
            Need to make changes?Tap “Below”
          </h1>
        </div>
        <div className="flex flex-row justify-center mt-2 mb-24">
          <button
            onClick={() => {
              history.push(`/emergencyMessaging?employeeId=${sortedCallData.warden.wardenId}&sort=true`);
            }}
            className="bg-blue-500 hover:bg-blue-700 text-white text-2xl font-bold border-black-900 py-2 rounded-full"
            style={{ width: 350, border: '2px solid #000000' }}
          >
            Go Back to Sorted Roll Call
          </button>
        </div>
      </div>
      <div
        className="text-2xl text-center text-white"
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          background: '#272223',
          height: 43,
        }}
      >
        <footer>
          <p>Powered by My-Lobby.com</p>
        </footer>
      </div>
    </>
  );
};
